import type { FC } from 'react';
import type { ListicleProps as Props } from './types.d';
import { withChildren } from '@builder.io/react';
import { cls } from '@/utils/cls';
import style from './Listicle.module.scss';
import RichText from '../RichText';
import { useColorProvider } from '@/utils/ColorProvider';
import { useLawsuits } from '@/utils/lawsuits';
import Loader from '../Loader';
const Listicle: FC<Props> = ({
  extendStyles,
  heading,
  copy,
  cardStyling,
  maxColumns,
  items,
  children,
  backgroundColor,
  itemHeight,
  useCollection,
  lawsuitCollection,
  usePageColors,
  buttonBackgroundColor,
  displayHeading
}) => {
  const _className = cls(style.root, extendStyles, style.center);
  const colStyles = cls(style.wrapper, !!cardStyling && style.cards);
  const {
    colors
  } = useColorProvider();
  const lawsuits = useLawsuits(lawsuitCollection?.id || null);

  // Convert lawsuit collection items to listicle items
  const displayItems = useCollection ? lawsuits : items;
  if (useCollection && lawsuits.length === 0) {
    return <Loader />;
  }
  return <section className={_className} style={{
    backgroundColor
  }} data-sentry-component="Listicle" data-sentry-source-file="Listicle.tsx">
			<div className={style.content}>
				{displayHeading && <div className={style.heading}>
						<RichText text={heading} />
						<RichText text={copy} />
					</div>}
				<div className={colStyles} style={{
        borderColor: colors.secondaryAccentColor,
        '--columns': maxColumns,
        '--item-height': `${itemHeight}px`
      } as React.CSSProperties} data-testid="listicle">
					{displayItems.map((item, i) => <div key={`item-${i}`} className={cls(style.item, !!item?.image ? '' : style.altPadding)} style={{
          backgroundColor: cardStyling ? 'white' : backgroundColor
        }}>
							{item?.image && <img src={item.image} alt="" role="presentation" />}
							<div className={style.content}>
								{!!item?.heading && <RichText text={item.heading} className={item.horizontalRule ? style.hr : ''} style={{
              borderColor: item.hrColor
            }} />}
								{!!item?.copy && <RichText text={item.copy} />}
							</div>
							{item?.button && item?.button?.buttonText && <a href={item?.button?.buttonHref || '#form'} className={style.itemButton} style={{
            backgroundColor: usePageColors ? colors.primaryAccentColor : buttonBackgroundColor || item.button.buttonColor
          }}>
									{item.button.buttonText}
								</a>}
						</div>)}
				</div>
				{children}
			</div>
		</section>;
};
export default withChildren(Listicle);